import React, { Component } from 'react';
import LOOKUP from 'constants/lookup';
// Basic Components
import Button from 'screens/components/basic/Button';
import DecimalInput from 'screens/components/basic/DecimalInput';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';
import BulkUpdateMemberPriceHistoryList from './BulkUpdateMemberPriceHistoryList';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class BulkUpdateMemberPriceDialog extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isOpen: false
        };
    }

    componentWillMount() {
        this.setState({ isOpen: this.props.isOpen });
    }

    componentWillReceiveProps(newProps) {
        if (this.state.isOpen !== newProps.isOpen) {
            this.setState({ isOpen: newProps.isOpen });
        }
    }

    closeDialog = () => {
        this.setState({ isOpen: false });
        this.props.onCancel();
    }

    confirm = () => {
        this.setState({ isOpen: false });
        this.props.onConfirm();
    }

    render() {
        const p = this.props;
        const s = this.state;
        return (
            <div>
                <DialogInput
                    title={<DialogHeaderWithClose text={p.title} classicClass="posDialogClassic" handleClose={() => this.closeDialog()} />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeDialog()} />,
                        <Button
                            key={2}
                            name="ConfirmButton"
                            label={LOOKUP.common.confirm.text}
                            primary={true}
                            onTouchTap={() => this.confirm()} />]}
                    modal={true}
                    open={s.isOpen}>
                    {p.message}
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <DecimalInput
                            type="number"
                            fullWidth={true}
                            id="bulkUpdateMemberPriceDialogPercentage"
                            name={`BulkUpdateMemberPriceDialog${LOOKUP.menu.admin.setting.memberDiscountPercentage.name}`}
                            floatingLabelText={LOOKUP.menu.admin.setting.memberDiscountPercentage.label}
                            hintText={LOOKUP.menu.admin.setting.memberDiscountPercentage.hintText}
                        />
                    </div> {/* .col for member discount percentage */}
                    <BulkUpdateMemberPriceHistoryList open={s.BulkUpdateMemberPriceHistoryList} title="Bulk Member Price History"/>
               
                </DialogInput>
                
            </div>
        );
    }
}

export default BulkUpdateMemberPriceDialog;